import { render } from "./SingleProject.vue?vue&type=template&id=040f510b"
import script from "./SingleProject.vue?vue&type=script&lang=js"
export * from "./SingleProject.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__